<div class="plaid-link" *transloco="let t">
	<div>
		<div id="plaidOfferHeader" *ngIf="!plaidConnectForIncomeVerified">
			<div class="op-header-2-font op-mb-16">{{ t('PLAID_CONNECT.connectYourBankForHigher') }}</div>
		</div>
		<div *ngIf="plaidConnectForIncomeVerified">
			<div *ngIf="!showBenefits">
				<div
					class="policy op-dark-grey"
					*ngIf="!incomeVerified"
					[ngClass]="{ 'op-mb-20': newMemberDebitCardEligibility, 'op-mb-8': !newMemberDebitCardEligibility }"
				>
					<span
						class="op-body-2-font"
						[innerHtml]="
							t(
								newMemberDebitCardEligibility
									? 'PLAID_CONNECT.mayResultInFasterProcessingTime'
									: 'PLAID_CONNECT.fasterProcessingTime'
							)
						"
					></span>
				</div>
			</div>
		</div>
		<op-plaid-benefits
			[showIncentive]="showIncentive"
			[newMemberDebitCardEligibility]="newMemberDebitCardEligibility"
			[plaidConnectForIncomeVerified]="plaidConnectForIncomeVerified"
			[incomeVerified]="incomeVerified"
		></op-plaid-benefits>
		<op-plaid-disclosure
			[subjectToEvaluation]="!newMemberDebitCardEligibility && !(plaidConnectForIncomeVerified && incomeVerified)"
			class="op-mb-10"
			id="plaidDisclaimer2"
		>
		</op-plaid-disclosure>
	</div>

	<div class="op-center">
		<op-plaid-button
			#plaidButton
			class="op-mb-20"
			id="plaidButton"
			minimum="true"
			[sectionType]="sectionType"
			[bankOnly]="bankOnly"
			[plaidConnectForIncomeVerified]="plaidConnectForIncomeVerified"
		></op-plaid-button>
		<div class="op-body-2-font plaid-message op-button-width" *ngIf="bankConnectEvent === 'WAITING'">
			{{ t('DOCUMENT_SUBMIT.proofOfBankAccount.loadingAccounts') }}
		</div>
		<op-alert
			class="plaid-message op-button-width"
			level="ERROR"
			*ngIf="showNoAccountsError && bankConnectEvent !== 'WAITING'"
		>
			{{ t('DOCUMENT_SUBMIT.proofOfBankAccount.noAccountsError') }}
		</op-alert>
	</div>

	<div *ngIf="showSkip" class="op-center op-mb-30">
		<button
			mat-flat-button
			color="secondary"
			class="op-full-width"
			id="skipPlaidLink"
			(click)="skipPlaid()"
			[opTagClick]="'skipPlaid'"
		>
			{{ t(skipButtonKey) }}
		</button>
	</div>

	<op-plaid-terms></op-plaid-terms>
	<op-debit-card-disclaimer class="op-mt-10" *ngIf="plaidConnectForIncomeVerified && newMemberDebitCardEligibility">
	</op-debit-card-disclaimer>
	<op-expansion-panel
		id="plaidWhichBank"
		[titleBold]="false"
		[title]="t('PLAID_CONNECT.whichBank')"
		[opTagClick]="'which bank'"
		[expanded]="false"
	>
		<span class="op-body-2-font">{{ t('PLAID_CONNECT.connectBank') }}</span>
	</op-expansion-panel>

	<ng-template #newMemberDebitCardExperience>
		<op-plaid-benefits
			[plaidConnectForIncomeVerified]="plaidConnectForIncomeVerified"
			[showIncentive]="showIncentive"
		></op-plaid-benefits>
	</ng-template>
</div>
